"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputSlider = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _useInputSlider = require("./useInputSlider");

var _InputSlider = require("./InputSlider.style");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   The minimum allowed value. If the `value` prop is not specified, the `min` will be setted as initial value. Important: it should not be equal to max.
  */
  min: _propTypes.number,

  /**
   The maximum allowed value. Important: it should not be equal to min.
  */
  max: _propTypes.number,

  /**
   The legal number intervals (the specific interval which the slider can step through values). `min` and `max` attributes should be divisible by step.
  */
  step: _propTypes.number,

  /**
   The value of the slider.
  */
  value: _propTypes.number,

  /**
   Callback function called when slider value change. It receives as argument an object with the current value and the filled percentage.
  */
  onChange: _propTypes.func,

  /**
   Callback function called when the slider loses focus.
  */
  onBlur: _propTypes.func
} : {};
const defaultProps = {
  min: 0,
  max: 10,
  step: 1,
  value: 0,
  onChange: () => {},
  onBlur: () => {}
};

const InputSlider = /*#__PURE__*/_react.default.forwardRef(({
  min,
  max,
  step,
  value,
  onChange,
  onBlur,
  ...props
}, ref) => {
  const {
    range,
    filled,
    onInputChange
  } = (0, _useInputSlider.useInputSlider)({
    max,
    min,
    value,
    onChange
  });
  return (0, _core.jsx)(_InputSlider.Input, (0, _extends2.default)({}, props, {
    type: "range",
    ref: ref,
    min: min,
    max: max,
    step: step,
    value: range,
    filled: filled,
    onChange: onInputChange,
    onBlur: onBlur
  }));
});

exports.InputSlider = InputSlider;
InputSlider.displayName = 'InputSlider';
process.env.NODE_ENV !== "production" ? InputSlider.propTypes = propTypes : void 0;
InputSlider.defaultProps = defaultProps;
InputSlider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InputSlider",
  "props": {
    "min": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The minimum allowed value. If the `value` prop is not specified, the `min` will be setted as initial value. Important: it should not be equal to max."
    },
    "max": {
      "defaultValue": {
        "value": "10",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The maximum allowed value. Important: it should not be equal to min."
    },
    "step": {
      "defaultValue": {
        "value": "1",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The legal number intervals (the specific interval which the slider can step through values). `min` and `max` attributes should be divisible by step."
    },
    "value": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The value of the slider."
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback function called when slider value change. It receives as argument an object with the current value and the filled percentage."
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback function called when the slider loses focus."
    }
  }
};